import { mapState } from "vuex";
export const distributionIndexMixins = {
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
    distributionTopBarList() {
      let topbarList = [];
      if (this.shopInfo.edcShopType == 2) {
        topbarList = [
          {
            name: "分销设置",
            isActive: false,
            path: "/distribution",
            icon:require("@/assets/img/menuIcons/icon-distribution.png")
          },
          {
            name: "分销记录",
            isActive: false,
            path: "/distribution/list",
            icon:require("@/assets/img/menuIcons/icon-distributionlist.png")
          },
          {
            name: "分销关系",
            isActive: false,
            path: "/distribution/shopRelationship",
            icon:require("@/assets/img/menuIcons/icon-distributionshopRelationship.png")
          },
          {
            name: "申请记录",
            isActive: false,
            path: "/distribution/applicationRecord",
            icon:require("@/assets/img/menuIcons/icon-distributionapplicationRecord.png")
          },
          {
            name: "提现记录",
            isActive: false,
            path: "/distribution/withdrawalRecord",
            icon:require("@/assets/img/menuIcons/icon-distributionwithdrawalRecord.png")
          },
        ];
      } else {
        topbarList = [
          {
            name: "分销设置",
            isActive: false,
            path: "/distribution",
            icon:require("@/assets/img/menuIcons/icon-distribution.png")
          },
          {
            name: "分销记录",
            isActive: false,
            path: "/distribution/list",
            icon:require("@/assets/img/menuIcons/icon-distributionlist.png")
          },
          {
            name: "分销关系",
            isActive: false,
            path: "/distribution/shopRelationship",
            icon:require("@/assets/img/menuIcons/icon-distributionshopRelationship.png")
          },
          {
            name: "申请记录",
            isActive: false,
            path: "/distribution/applicationRecord",
            icon:require("@/assets/img/menuIcons/icon-distributionapplicationRecord.png")
          },
          {
            name: "提现记录",
            isActive: false,
            path: "/distribution/withdrawalRecord",
            icon:require("@/assets/img/menuIcons/icon-distributionwithdrawalRecord.png")
          },
        ];
      }
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
        if (val.childrenPath) {
          if (~val.childrenPath.indexOf(this.$route.path)) {
            val.isActive = true;
          }
        }
      });
      return topbarList;
    },
  },
}
